import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useProgress } from '../hooks/useProgress';
import courseData from '../data/courseData';
import '../App.css';

const LessonPage = () => {
  const { slug } = useParams();
  const { completeLesson, isLessonCompleted } = useProgress();
  
  // Find the lesson by ID (slug is the lesson ID)
  const lesson = courseData.find(l => l.id === parseInt(slug));
  
  if (!lesson) {
    return (
      <div className="lesson-page">
        <div className="lesson-header">
          <h2>Lesson not found</h2>
          <Link to="/" className="back-button">Back to Course</Link>
        </div>
      </div>
    );
  }
  
  const isCompleted = isLessonCompleted(lesson.id);
  
  const handleMarkComplete = () => {
    completeLesson(lesson.id);
  };
  
  const renderResources = () => {
    if (!lesson.resources || lesson.resources.length === 0) {
      return null;
    }
    
    return (
      <div className="resources-section">
        <h3>Downloadable Resources</h3>
        <div className="resources-list">
          {lesson.resources.map((resource, index) => (
            <div key={index} className="resource-item">
              <a 
                href={process.env.PUBLIC_URL + resource.path} 
                target="_blank" 
                rel="noopener noreferrer"
                className="resource-link"
              >
                <div className="resource-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="12" y1="18" x2="12" y2="12"></line>
                    <line x1="9" y1="15" x2="15" y2="15"></line>
                  </svg>
                </div>
                <div className="resource-info">
                  <h4>{resource.name}</h4>
                  <p>{resource.description}</p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  return (
    <div className="lesson-page">
      <div className="lesson-header">
        <h2>Lesson {lesson.id}: {lesson.title}</h2>
        <Link to="/" className="back-button">Back to Course</Link>
      </div>
      
      <div className="lesson-content">
        <div className="lesson-description">
          <p>{lesson.description}</p>
        </div>
        
        <div className="lesson-objectives">
          <h3>Learning Objectives</h3>
          <ul>
            {lesson.objectives.map((objective, index) => (
              <li key={index}>{objective}</li>
            ))}
          </ul>
        </div>
        
        {renderResources()}
        
        <div className="lesson-completion">
          <button 
            className={`complete-button ${isCompleted ? 'completed' : ''}`}
            onClick={handleMarkComplete}
          >
            {isCompleted ? 'Completed ✓' : 'Mark as Complete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LessonPage;
